'use strict';
const envelopeMetadata = (envelope) => {
		return Object({
			collaborator: envelope.header && {displayName: envelope.header.description, sessionId: envelope.header.sessionId},
			ts: envelope.header && envelope.header.ts
		});
	},
	extendWithEnvelopeMetadata = (event, envelopeMeta)  => {
		return Object.assign(Object.assign({}, envelopeMeta), event);
	};

module.exports = function eventsFromEnvelope(envelope) {
	const sessionId = envelope && envelope.header && envelope.header.sessionId,
		events = (sessionId && envelope.events) || [],
		envelopeMeta = envelopeMetadata(envelope);
	return events.map(evt => extendWithEnvelopeMetadata(evt, envelopeMeta));

};
